var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 mb-3",domProps:{"innerHTML":_vm._s(_vm.$t('messages.sale_info_send_mail'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }